import { RouteComponentProps } from "@reach/router";

export const MyAccountGroup: React.FC<RouteComponentProps> = ({ children }) => {
  return <>{children}</>;
};
